import { createSelector } from "reselect";
import get from "lodash/get";
import {
  transactionDetailsSelector,
  numberFormatSelector,
  sessionTokenSelector,
  orderSelector
} from "ducks/selectors";
import { paths, BRAND_NAME, MOBILE_APP_DEEP_LINK } from "utils/constants";
import { urlParam, formatDisplayNumber } from "utils/helpers";

const shopPaymentDomain = state =>
  get(state, "form.ShopPaymentForm.values", {});

export const shopPaymentSelector = createSelector(
  shopPaymentDomain,
  shopPayment => shopPayment
);

export const makeSelectShopPaymentForm = () => shopPaymentSelector;

export const makeSelectShopPaymentFormInitialValues = () =>
  createSelector(() => {
    return {
      txn_id: urlParam("id")
    };
  });

export const makeSelectShopPaymentPayload = () =>
  createSelector(
    shopPaymentSelector,
    transactionDetailsSelector,
    numberFormatSelector,
    sessionTokenSelector,
    orderSelector,
    (shopPayment, transactionDetails, numberFormat, token, order) => {
      const { code, channel_code } = get(shopPayment, "payment_method", {});
      const payment_methods = { code, channel_code };
      const txn_id = urlParam("id");
      const number = get(transactionDetails, "phone_number");
      const phoneNumber = formatDisplayNumber(number, numberFormat);
      const description = `${BRAND_NAME} - #${phoneNumber}`;
      const origin = MOBILE_APP_DEEP_LINK || window.location.origin;
      const status_path = paths.DASHBOARD;
      const status_url = `${origin}${status_path}?id=${txn_id}`;
      const order_id = get(order, "order_ref", "");

      return {
        order_id,
        token,
        txn_id,
        description,
        payment_methods,
        success_redirect_url: status_url,
        failure_redirect_url: status_url
      };
    }
  );
